import React from 'react';
import CommonSVGIcon, { Props } from './CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 20 20">
      <path d="M17.5 4.01071L15.9893 2.5L10 8.48929L4.01071 2.5L2.5 4.01071L8.48929 10L2.5 15.9893L4.01071 17.5L10 11.5107L15.9893 17.5L17.5 15.9893L11.5107 10L17.5 4.01071Z"/>
    </CommonSVGIcon>
  );
}
